
let initialState: any = {};
type  InitialStateType = typeof initialState;
const sidebarReducer = (state = initialState, action: any): InitialStateType => {
    return state;
}
export default sidebarReducer;
